import { render, staticRenderFns } from "./_Water.vue?vue&type=template&id=c82acc3e&"
import script from "./_Water.vue?vue&type=script&lang=js&"
export * from "./_Water.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports